import { useQuery } from '@apollo/client';

import { RetrievedInvoiceDocument } from './graphql/retrievedInvoice.gql';

export const useRetrievedInvoiceQuery = (invoiceId: string) => {
  const { data, ...hook } = useQuery(RetrievedInvoiceDocument, {
    skip: !invoiceId,
    variables: { invoiceId },
  });

  if (!data || hook.loading || hook.error) {
    return { retrievedInvoice: null, ...hook };
  }

  return {
    retrievedInvoice: data.invoice,
    ...hook,
  };
};

export type RetrievedInvoice = NonNullable<
  NonNullable<
    Awaited<ReturnType<typeof useRetrievedInvoiceQuery>>
  >['retrievedInvoice']
>;
